import { withGetItShippedWithAutoReplenishmentProps } from 'viewModel/productPage/deliveryOptions/getItShippedWithAutoReplenishment/withGetItShippedWithAutoReplenishmentProps';
import GetItShippedWithAutoReplenishment from 'components/ProductPage/DeliveryOptions/GetItShippedWithAutoReplenishment/GetItShippedWithAutoReplenishment';

export default withGetItShippedWithAutoReplenishmentProps(GetItShippedWithAutoReplenishment);
